import React, { CSSProperties } from 'react';
import { Spin } from 'antd';

interface IProps {
	display?: boolean
}

function TableLoadingIndicator(props: IProps) {
	let style: CSSProperties = {
		background: "white",
		opacity: .6,
	};

	if (!props.display) return null;
	return (
		<div className="pos-abs-cover" style={style}>
			<Spin className="pos-abs-center" size="large" delay={2000} />
		</div>
	);
};

export default TableLoadingIndicator;